import React from 'react';

const { Provider: DeleteServiceProvider, Consumer: DeleteServiceConsumer } = React.createContext();

export { DeleteServiceProvider, DeleteServiceConsumer };
